export const sesameTouchProAuthType = {
  card: 'card',
  finger: 'finger',
  face: 'face',
  palm: 'palm',
  password: 'password',
};
